import BaseEntity from '../base/BaseEntity.model';

export default class SyncAlertasResult {
    public hogarCodigo?: string;
    public hogarId?: number;
    public success: boolean;
    public alertas: number;
    public observaciones: number;
    public sanciones: number;
    public suspensiones: number;
    constructor() {
        this.success = false;
        this.alertas = 0;
        this.suspensiones = 0;
        this.sanciones = 0;
        this.observaciones = 0;
    }
}
export class HogarAlerta extends BaseEntity {
     public alertaId?: number;
    public hogarId?: number;
    public codigoHogar?: string;
    public fechaCreacion?: Date;
    public fechaFin?: Date;
    public fechaSync?: Date;
    public titulo?: Date;
    public mensaje?: Date;
    public vigente?: boolean;
  }
export class HogarSancion extends BaseEntity {
    public hogarId?: number;
    public codigoHogar?: string;
    public estado?: string;
    public ano?: number;
    public mes?: number;
    public causaSancion?: string;
    public razon?: string;
    public vigencia?: number;
    public fecha?: Date;
    public fechaSync?: Date;
    public vigente?: boolean;
 }
export class HogarObservacion extends BaseEntity {
    public hogarId?: number;
    public codigoHogar?: string;
    public estado?: string;
    public causaObservacion?: string;
    public fechaLiberacion?: Date;
    public fechaObservacion?: Date;
    public fechaSync?: Date;
    public institucion?: string;
    public razon?: string;
    public vigente?: boolean;
 }
export class HogarSuspension extends BaseEntity{
    public hogarId?: number;
    public codigoHogar?: string;
    public estado?: string;
    public ano?: number;
    public mes?: number;
    public apellidos?: string;
    public nombres?: string;
    public subsidio?: string;
    public tarjeta?: string;
    public fechaSync?: Date;
    public fecha?: Date;
    public razon?: string;
 }